import type { AuthorizedDeviceViewModel } from './authorizedDeviceMappers';

export function isBrowserAuthorizedFromList(devices: AuthorizedDeviceViewModel[]): boolean {
  return devices.some((d) => d.isCurrentDevice && d.isActive);
}
